let host = null;

if(window.location.hostname === "127.0.0.1" || window.location.hostname === 'localhost') {
    host =  'http://127.0.0.1:8000/';
} else {
    host =  'https://are-backend.tradinos.com/';
}

export default {
    host
};
